import React from 'react';

import EditForm from './EditForm';
import FormLoader from '../shared/forms/FormLoader';
import PropTypes from 'prop-types';

const InteractionEditor = ({
    editId,
    customerId,
    cancelEdit,
    fetchData
}) => {
    const getUrl = `/api/interactions/edit/${editId}?customerId=${customerId}`;
    const postUrl = `/api/interactions/edit`;

    return (
        <FormLoader
            cancelEdit={cancelEdit}
            fetchData={fetchData}
            loadForm={editId !== undefined}
            getUrl={getUrl}
            postUrl={postUrl}
        >
            <EditForm cancelEdit={cancelEdit} />
        </FormLoader>
    );
}

InteractionEditor.propTypes = {
    editId: PropTypes.number,
    customerId: PropTypes.number,
    cancelEdit: PropTypes.func,
    fetchData: PropTypes.func
};

export default InteractionEditor;